"use client";

import TerminalArt from "./terminal-art";

/**
 * The /desktop hero centerpiece: a retro CRT terminal playing a looping
 * capture session. The scale wrapper keeps the fixed-pixel illustration crisp
 * while fitting phones; the whole thing is decorative.
 */
export default function DesktopHeroArt({ className }: { className?: string }) {
  return (
    <div
      className={`relative mx-auto h-[320px] w-full max-w-[560px] md:h-[460px] ${className ?? ""}`}
      aria-hidden="true"
    >
      <div className="absolute inset-0 flex origin-center scale-[0.62] items-center justify-center sm:scale-[0.82] md:scale-100">
        <TerminalArt />
      </div>
    </div>
  );
}
